module.exports = __webpack_public_path__ + "img/2013.64ba587c.png";